import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  TablePagination,
  Typography
} from '@material-ui/core';

import {
  Search as SearchIcon,
} from 'react-feather';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import firebase from '../../../../Firebase';
import 'firebase/database';
import { FormattedMessage, useIntl } from "react-intl";

import { updateQueryAuth_AuthID,
  updateQueryAuth_FacilityName
} from 'actions/query';



const AuthTable = props => {
  const { className, queryAuthParams, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();


  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);
  const [queryAuthID, setQueryAuthID] = useState('');
  const [queryFacilityName, setQueryFacilityName] = useState('');


  const searchData = (authId, facility_name) => {

    var dbRef = firebase.database().ref('/auth/');
    dbRef.on('value', function(snapshot) {

      var list = [];

      snapshot.forEach(function(childSnapshot){

        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();

        var shouldAdd = true;
        if (facility_name !== '') {
          if ( childData.facility_name && childData.facility_name.includes(facility_name)) {
                // console.log("include: ", childData.facility_name);
          } else {
            shouldAdd = false;
          }
        }

        if (authId !== ''){
          if(childData.auth_id && childData.auth_id.includes(authId)){
          } else {
            shouldAdd = false;
          }
        }


        if  (shouldAdd){
          var doc ={
            auth_id: childKey,
            backend_url: childData.backend_url,
            caregiver_id: childData.caregiver_id,
            caregiver_name: childData.caregiver_name,
            facility_id: childData.facility_id,
            facility_name: childData.facility_name,
            password: childData.password,
            isActive: childData.isActive,
            isOnlySleep: childData.isOnlySleep,
          };

          list.push(doc);
        }
      });

      setListData(list);
    });

  }


  const handleSearch = event => {
    searchData(queryAuthID, queryFacilityName);
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    props.updateQueryAuth_AuthID('');
    props.updateQueryAuth_FacilityName('');

    setQueryAuthID('');
    setQueryFacilityName('');
  }

  const handleQueryAuthID = (event) => {
    setQueryAuthID(event.target.value);
    props.updateQueryAuth_AuthID(event.target.value);
  }

  const handleQueryFacilityName = (event) => {
    setQueryFacilityName(event.target.value);
    props.updateQueryAuth_FacilityName(event.target.value);
  }


  const keyUp = (event) => {
    if (event.key === "Enter") {
      handleSearch();
      event.preventDefault();
    }
  }

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  useEffect(() => {

    if (queryAuthParams.queryAuthAuthID || queryAuthParams.queryAuthFacilityName){
      searchData(queryAuthParams.queryAuthAuthID, queryAuthParams.queryAuthFacilityName);
    }

    setQueryAuthID(queryAuthParams.queryAuthAuthID);
    setQueryFacilityName(queryAuthParams.queryAuthFacilityName);

  }, []);


  const startRow = (page * rowsPerPage);


  return (
    <Card className={clsx(classes.root, className)} {...rest} >
      <Box m={1} p={2}>
        <Box mt={2}
          display="flex"
          alignItems="center"
          justifyContent="start"
          flexGrow={1}>

          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}
            onChange={handleQueryAuthID}
            label={formatMessage({id:'login_id'})}
            placeholder={formatMessage({id:'login_id'})}
            value={queryAuthID}
            variant="outlined"
            onKeyUp={keyUp}
          />


          <TextField className={classes.queryField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
                </InputAdornment>
              )
            }}
            onChange={handleQueryFacilityName}
            label={formatMessage({id:'facility_name'})}
            placeholder={formatMessage({id:'facility_name'})}
            value={queryFacilityName}
            variant="outlined"
            onKeyUp={keyUp}
          />

          <Button variant="contained" color="primary" size="large" className={classes.bulkAction} onClick={handleSearch}><FormattedMessage id="search" /></Button>
          <Button variant="outlined" size="large" className={classes.bulkAction} onClick={handleClear}><FormattedMessage id="initialize" /></Button>
        </Box>
      </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width={COLUMN_WIDTH.AUTH_ID} align="center" ><FormattedMessage id="login_id" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.BACKEND_URL} align="center">BackEnd</TableCell>
                  <TableCell width={COLUMN_WIDTH.FACILITY_ID} align="center"><FormattedMessage id="facility_id" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.FACILITY_NAME} align="center"><FormattedMessage id="facility_name" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.CAREGIVER_ID} align="center"><FormattedMessage id="caregiver_id" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.CAREGIVER_NAME} align="center"><FormattedMessage id="caregiver_name" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.PASSWORD} align="center"><FormattedMessage id="password" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.ISACTIVE} align="center"><FormattedMessage id="activation" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.IS_ONLY_SLEEP} align="center"><FormattedMessage id="isOnlySleep" /></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0 + startRow, rowsPerPage + (page * rowsPerPage)).map(module => (
                  <TableRow
                    className={classes.tableRow}
                    key={module.deviceId}
                    component={RouterLink} to={`/auth/update/${module.auth_id}`}
                  >
                    <TableCell width={COLUMN_WIDTH.AUTH_ID}>{module.auth_id}</TableCell>
                    <TableCell width={COLUMN_WIDTH.BACKEND_URL} align="center">{module.backend_url}</TableCell>
                    <TableCell width={COLUMN_WIDTH.FACILITY_ID} align="center">{module.facility_id}</TableCell>
                    <TableCell width={COLUMN_WIDTH.FACILITY_NAME} align="center">{module.facility_name}</TableCell>
                    <TableCell width={COLUMN_WIDTH.CAREGIVER_ID} align="center" >{module.caregiver_id}</TableCell>
                    <TableCell width={COLUMN_WIDTH.CAREGIVER_NAME} align="center">{module.caregiver_name}</TableCell>
                    <TableCell width={COLUMN_WIDTH.PASSWORD} align="center"><Typography variant="body2">{module.password}</Typography></TableCell>
                    <TableCell width={COLUMN_WIDTH.ISACTIVE} align="center">{module.isActive === 1 ? formatMessage({id:'active'}) : formatMessage({id:'inactive'})}</TableCell>
                    <TableCell width={COLUMN_WIDTH.IS_ONLY_SLEEP} align="center">{module.isOnlySleep === 1 ? formatMessage({id:'active'}) : formatMessage({id:'inactive'})}</TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};


AuthTable.propTypes = {
  className: PropTypes.string,
};


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateQueryAuth_AuthID,
    updateQueryAuth_FacilityName,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryAuthParams: state.queryAuthParams
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AuthTable));



// export default withRouter(AuthTable);


const COLUMN_WIDTH = {
  AUTH_ID: '10%',
  BACKEND_URL: '15%',
  FACILITY_ID: '5%',
  FACILITY_NAME: '15%', //50
  CAREGIVER_ID: '7%', //51
  CAREGIVER_NAME: '13%', //61
  PASSWORD: '10%', //66
  ISACTIVE: '10%', //66
  IS_ONLY_SLEEP: '10%', //66
}


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight: 20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
